import GModal from "components/ui/modal/Modal";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {Box,  Flex, Stack, useToast, FormControl, FormErrorMessage, FormLabel, Input as ChInput, Text} from "@chakra-ui/react";
import { Controller, useForm } from "react-hook-form";
import GButton from "components/ui/button/Button";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import { useDispatch, useSelector } from "react-redux";
import Input from "components/form/Input";
import {
  editTransferOrders,
  editTransfereOrdersItemsQuantities,
  getEditQuantities,
  getTranOrderItems,
} from "../../services/transfersOrdersService";

const EditQuantitiesModal = ({ onClose, id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const toast = useToast({  position: "top",  duration: 3000,  status: "success",});
  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });
  const {handleSubmit,control,  getValues,  watch,   setValue,   register ,  formState: { errors }, trigger,  setError, clearErrors, } = useForm();

  const transfereOrders = useSelector((state) => state.transfersorders);
  console.log(transfereOrders);
  const [itemData, setItemData] = useState({});
  const [dataValid, setDatavalid] = useState(true);

  useEffect(() => {
    dispatch(getEditQuantities(id));
  }, [dispatch, id]);

  useEffect(() => {
    const initialItemData = {};

    transfereOrders.data2.forEach((el) => {
      // Store each element in a separate object
      initialItemData[el.TransferOrdersItemsId] = {
        TransferOrdersItemsId: el.TransferOrdersItemsId,
        Quantity: el.Quantity,
      };
    });

    // Set the state with both the object and the array
    setItemData(initialItemData);
  }, [transfereOrders.data2]);

  const handleQuantityChange = (newQuantity, itemId) => {
    // Step 3: Update the state with the new data using a unique identifier
    setItemData((prevData) => {
      return {
        ...prevData,
        [itemId]: {
          ...prevData[itemId],
          Quantity: newQuantity,
        },
      };
    });
  };

  const handelValidate = (values) => {
    let isValid = true;
  
    const items = values.TransOItems;
    items.forEach((el) => {
      if (el.Quantity === undefined || el.Quantity === "" || el.Quantity < 0) {
        toast2({ description: t("validation.required") });
        isValid = false;
      }
    });
  
    if (isValid) {
      items.forEach((el) => {
        dispatch(editTransfereOrdersItemsQuantities(values))
          .unwrap()
          .then((_) => {
            toast({ description: t("pages.transfers_orders.edited_succesfuly") });
            dispatch(getTranOrderItems(id));
            onClose();
          });
      });
    } else {
      setDatavalid(false);
    }
  };

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.transfers_orders.edit_quantities")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              const editedItems = Object.keys(itemData).map((itemId) => ({
                TransferOrdersItemsId: parseInt(itemId, 10),
                Quantity: itemData[itemId].Quantity,
              }));
              values.TransOItems = editedItems;
              values.TransferOrdersId = id.TransferOrdersId;
              handelValidate(values);
            })}
          >
            <Stack spacing={6}>
              {transfereOrders.data2.map( (el) => (
                  <Box>
                    <Text
                      marginBottom={"7px"}
                      fontSize={"1rem"}
                      fontWeight={"500"}
                      textTransform={"capitalize"}
                      textAlign={"start"}
                      marginInlineEnd={"0.75rem"}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      {el.InventoryItemNameEng}
                    </Text>
                    <ChInput
                      value={itemData[el.TransferOrdersItemsId]?.Quantity || ""}
                      name="Quantity"
                      type="number"
                      onChange={(e) =>
                        handleQuantityChange(
                          e.target.value,
                          el.TransferOrdersItemsId
                        )
                      }
                    />

                  </Box>

                )
              )}

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default EditQuantitiesModal;
